import React from "react";

export const Auth0Feature = ({ title, description, icon }) => (
  <div className="fjelldigi-feature">
    <h3 className="fjelldigi-feature__headline">
      <img
        className="fjelldigi-feature__icon"
        src={icon}
        alt="external link icon"
      />
      {title}
    </h3>
    <p className="fjelldigi-feature__description">{description}</p>
  </div>
);
